import {
  Box,
  FormControlLabel,
  Checkbox,
  Typography,
  FormHelperText,
} from '@mui/material';

const CpdCheckboxCard = ({
  checked,
  onChange,
  label,
  description,
  disabled = false,
  disabledHelperText,
  selected = false,
  error = false,
  errorMessage,
  sx = {},
}) => {
  const showSelectedBorder = selected || checked;

  const card = (
    <Box
      sx={{
        flex: 1,
        border: showSelectedBorder ? '2px solid' : '1px dashed',
        borderColor: showSelectedBorder ? 'primary.main' : 'grey.400',
        p: 2,
        borderRadius: 2,
        cursor: disabled ? 'not-allowed' : 'pointer',
        opacity: disabled ? 0.6 : 1,
        ...sx,
      }}
      onClick={() => !disabled && onChange(!checked)}>
      <FormControlLabel
        control={
          <Checkbox checked={checked} disabled={disabled} size='small' />
        }
        label={
          <>
            <Typography variant='body1' sx={{ fontWeight: 'bold' }}>
              {label}
            </Typography>
            {description && (
              <Typography variant='body2' sx={{ color: 'text.secondary' }}>
                {description}
              </Typography>
            )}
            {disabled && disabledHelperText && (
              <Typography
                variant='body2'
                sx={{ color: 'text.secondary', mt: 0.5, fontStyle: 'italic' }}>
                {disabledHelperText}
              </Typography>
            )}
          </>
        }
      />
      {error && errorMessage && (
        <FormHelperText
          error
          sx={{ fontWeight: 'bold', fontSize: '0.9em', ml: 4 }}>
          {errorMessage}
        </FormHelperText>
      )}
    </Box>
  );

  return card;
};

export default CpdCheckboxCard;
